export const lightMode = {
    loaderOverLayColor: "rgba(255, 255, 255, 0.6)",
    headerBgColor: "blue.600",
    headerIconColor: "blue.500",
    navbarBorderColor: "gray.400",
    menuIconHoverColor: "gray.500",
    hoverColor: "gray.100",
    containerBorderColor: "gray.300",
    boxBackgroundColor2: "gray.90",
    boxBackgroundColor: "white",
    chartsTextColor: '#1A202C',
    textColor: "gray.700",
    inputBoxBorderColor: "gray.300",
    inputFocusBorderColor: "gray.900",
    inputTextColor: "gray.900",
    inputErrorBorderColor: "red.500",
    customerCardBorderColor: "#d9d8d7",
    customerDetailsColor: "gray.50",
}

export const darkMode = {
    loaderOverLayColor: "rgba(0, 0, 0, 0.4)",
    headerBgColor: "gray.800",
    headerIconColor: "gray.700",
    navbarBorderColor: "gray.800",
    menuIconHoverColor: "white",
    hoverColor: "gray.400",
    containerBorderColor: "gray.600",
    chartsTextColor: '#ffffff',
    textColor: 'gray.100',
    boxBackgroundColor: "gray.900",
    customerCardBorderColor: "#595958",
    inputBoxBorderColor: "gray.800",
    inputFocusBorderColor: "white",
    inputTextColor: "white",
    inputErrorBorderColor: "red.400",
    customerDetailsColor: 'gray.800'
}

export const MenuIconColor = "white";
export const MenuBgColor = "#00A884";
export const menuZIndex = "10000";
export const AppLoaderZIndex = "9999";